import React, { Component } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import SicknessForm from '../../forms/Sicknesses';

import { hideElementForNonAdminsAndNonManagers } from '../../utilities/Forms.js'

import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SlidingPane from "../../components/shared/ScrollableSlidingPane";

class PersonSicknesses extends Component {

  constructor(props) {
    super(props);

    this.handleUpdatePanel = this.handleUpdatePanel.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  state = {
    sicknesses: [],

    newPanelToggle: false,
    updatePanelToggle: false,
    sicknessId: null,
    loaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
  }

  handleUpdatePanel(event) {
    let id = event.currentTarget.id;

    this.setState({
      sicknessId: id,
      updatePanelToggle: true
    });
  }

  closePanel() {
    this.setState({
      sicknessId: null,
      newPanelToggle: false,
      updatePanelToggle: false
    });

    this.componentDidMount();
  }

  emptySicknesses() {
    if (this.state.sicknesses.length === 0) {
      return (
        <div className="long-tr">
          <div className="long-td">
            There are no sicknesses for this year.
          </div>
        </div>
      )
    }
  }

  inThePast(time) {
    return new Date(time) < new Date();
  }

  render() {
    const { sicknesses, loaded, unauthorized, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return (
        <div>
          {error["errors"].map((errors, index) => (
            <div className="warning-box" key={index}>{errors}</div>
          ))}
        </div>
      )
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      let person_id = this.props.person_id;

      return (
        <div>
          <h3 className="inline-block">Sicknesses</h3>

          <Link to={`#`} onClick={this.handleNewPanel}>
            <div className={`button new-button ${hideElementForNonAdminsAndNonManagers()}`}>New Sickness</div>
          </Link>

          <div className="table big-table" data-testid="table">
            <div className="tr heading">
              <div className="th">Start Time</div>
              <div className="th">End Time</div>
              <div className="th">Reason</div>
              <div className="th">Doctor Note Provided?</div>
            </div>
            {sicknesses.map((sickness) => (
              <div onClick={this.handleUpdatePanel} id={sickness.id} key={sickness.id} className="tr clickable">
                <div className="td">{sickness.start_time}</div>
                <div className="td">{sickness.end_time}</div>
                <div className="td">{sickness.reason}</div>
                <div className="td center">{sickness.doctor_note_provided ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</div>
              </div>
            ))}
          </div>
          {this.emptySicknesses()}

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Sickness" width="50%"
            onRequestClose={() => { this.closePanel() }}>
            <SicknessForm mode="create" id={this.state.sicknessId} person_id={person_id} closePanel={this.closePanel} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.updatePanelToggle} title="Update Sickness" width="50%"
            onRequestClose={() => { this.closePanel() }}>
            <SicknessForm mode="update" id={this.state.sicknessId} person_id={person_id} closePanel={this.closePanel} />
          </SlidingPane>
        </div>
      );
    }
  }

  componentDidMount() {
    let person_id = this.props.person_id;

    request('GET', `/v1/a/people/${person_id}/sicknesses`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ sicknesses: data, loaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }
}

export default withRouter(PersonSicknesses);
